import { Nullable } from "sonobello.utilities.react.mui";

/** An organization of url variables which can be assembled into the connection url to authenticate a user. */
export class OAuthConfiguration {
  private readonly clientId: string;
  private readonly codeChallenge: Nullable<string>;
  private readonly codeChallengeMethod: Nullable<string>;
  private readonly redirectUri: string;
  private readonly scope: string;
  private readonly url: string;

  constructor(
    url: string,
    clientId: string,
    redirectUri: string,
    scope: string,
    codeChallenge?: string,
    codeChallengeMethod?: string
  ) {
    this.clientId = clientId;
    this.codeChallenge = codeChallenge || null;
    this.codeChallengeMethod = codeChallengeMethod || null;
    this.redirectUri = redirectUri;
    this.scope = scope;
    this.url = url;
  }

  /** Construct the OAUTH url required for the authentication request. */
  BuildUrl = (): string => {
    let constructedUrl = `${this.url}?response_type=code&client_id=${this.clientId}&scope=${this.scope}&redirect_uri=${this.redirectUri}`;
    if (this.codeChallenge) constructedUrl += `&code_challenge=${this.codeChallenge}`;
    if (this.codeChallengeMethod) constructedUrl += `&code_challenge_method=${this.codeChallengeMethod}`;
    return constructedUrl;
  };
}

/** An OAuth configuration for authenticating with the CRM's Api. */
export class CrmOAuthConfiguration extends OAuthConfiguration {
  constructor(url: string, clientId: string, redirectUri: string, codeChallenge: string) {
    super(url, clientId, redirectUri, "api%20openid%20offline_access", codeChallenge, "S256");
  }
}

/** An OAuth configuration for authenticating with the InContact Api. */
export class IvrOAuthConfiguration extends OAuthConfiguration {
  constructor(url: string, clientId: string, redirectUri: string) {
    super(url, clientId, redirectUri, "openid");
  }
}
